
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Plan } from "@/components/pricing/types";
import { useToast } from "@/hooks/use-toast";

export const usePlans = (productId: string | undefined) => {
  const { toast } = useToast();
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      if (!productId) {
        console.log('No productId provided');
        setLoading(false);
        return;
      }
      
      try {
        console.log('Fetching plans for productId:', productId);
        const { data, error } = await supabase
          .from('plans')
          .select('*')
          .eq('feature_id', productId)
          .eq('status', 'active');

        if (error) throw error;

        console.log('Raw data from plans query:', data);
        
        if (!data || data.length === 0) {
          console.log('No plans found for this product');
          setPlans([]);
          setLoading(false);
          return;
        }

        const transformedPlans = data.map(plan => ({
          plan_id: plan.id,
          plan_name: plan.name,
          price: Number(plan.price),
          duration: plan.duration,
          type: plan.type,
          status: plan.status
        }));
        
        console.log('Transformed plans:', transformedPlans);
        setPlans(transformedPlans);
      } catch (error) {
        console.error('Error fetching plans:', error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "Failed to fetch plans",
        });
      } finally {
        setLoading(false);
      }
    };

    if (productId) {
      fetchPlans();
    }
  }, [productId, toast]);

  return { plans, loading };
};

